// Internal =====================================
import PropTypes from 'prop-types';
import { Component } from 'react';
// const { Input } = Validation.components;

class CheckBox extends Component {

    constructor(props) {

        super(props);
        this._bind('handleChange');

        this.state = {
            isChecked: this.props.isChecked,
            isDisabled: this.props.isDisabled
        };
    }

    componentWillReceiveProps(nextProps) {

        // componentWillReceiveProps runs this method twice that's why I used an if statement
        if (this.props.isChecked !== nextProps.isChecked) {
            const { isChecked = false } = nextProps;

            this.setState({ isChecked });
        }

        if (this.props.isDisabled !== nextProps.isDisabled) {
            const { isDisabled = false } = nextProps;

            this.setState({ isDisabled });
        }
    }

    handleChange(event) {

        const target = event.target;
        const checked = target.checked;

        this.setState({ checked });

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(event);
        }
    }

    render() {

        const { id, name, value, label, labelClass, classNames } = this.props;

        return (
        	<label className={ classNames }>
                <input
                    id={ id }
                    type="checkbox"
                    name={ name }
                    value={ value }
                    onChange={ this.handleChange }
                    checked={ this.state.isChecked }
                    disabled={ this.state.isDisabled } />
                <span>{ label }</span>
            </label>
        );

    }
}

CheckBox.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.any,
    onChange: PropTypes.func,
    isChecked: PropTypes.bool,
    isDisabled: PropTypes.bool,
};

CheckBox.defaultProps = {
    id: '',
    name: '',
    value: '',
    label: '',
    isChecked: false,
    isDisabled: false,
    classNames: 'rf-checkbox',
    onChange: () => {}
};

export default CheckBox;
